module.exports = __webpack_public_path__ + "img/banner.be7656b6.png";